module.exports = window["wp"]["compose"];